(() => {
  'use strict';
  const init = () => {
    document.querySelectorAll('[data-person-limit][data-pl2-reminder]').forEach(group => {
      if (group.dataset.pl2Ready) return;
      const quantity = group.querySelector('[data-person-limit-quantity]');
      const plus = group.querySelector('[data-person-limit-plus]');
      const notice = group.querySelector('[data-person-limit-notice]');
      if (!quantity || !plus || !notice) return;
      group.dataset.pl2Ready = 'true';
      notice.hidden = true;
      document.body.append(notice);
      let timer;
      const position = () => {
        if (notice.hidden) return;
        const viewport = window.visualViewport;
        const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
        const width = viewport?.width || window.innerWidth, height = viewport?.height || window.innerHeight;
        const margin = 12;
        notice.style.maxWidth = Math.min(340, Math.max(0, width - margin * 2)) + 'px';
        const anchor = plus.getBoundingClientRect(), floating = notice.getBoundingClientRect();
        const above = anchor.top - floating.height - 10;
        const preferredTop = above >= top + margin ? above : anchor.bottom + 10;
        const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));
        notice.style.left = clamp(anchor.left + anchor.width / 2 - floating.width / 2, left + margin, left + width - floating.width - margin) + 'px';
        notice.style.top = clamp(preferredTop, top + margin, top + height - floating.height - margin) + 'px';
      };
      plus.addEventListener('click', () => {
        quantity.value = '1';
        clearTimeout(timer);
        notice.hidden = false;
        position();
        timer = setTimeout(() => { notice.hidden = true; }, 3000);
      });
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        clearTimeout(timer);
        quantity.value = '1';
        notice.hidden = true;
      });
      window.addEventListener('scroll', position, {passive:true, capture:true});
      window.addEventListener('resize', position, {passive:true});
      window.visualViewport?.addEventListener('scroll', position, {passive:true});
      window.visualViewport?.addEventListener('resize', position, {passive:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
